export { default as ErrorAcceptGmoi } from './ErrorAcceptGmoi';
